//
// Default script app
// =============================================================================

$(document).ready(function () {
  // YOUR CODE HERE

  //
  // Page script
  // =============================================================================
  
  // $('#sectionIntro').YTPlayer({
  //   fitToBackground: true,
  //   videoId: 'F6X8HHShn4Y',
  // })
  
  // var options = { videoId: 'F6X8HHShn4Y', start: 3 };
  // $('.page-main').tubular(options);
  
  // Variables
  var menuMobileIcon = $('#menuMobileIcon'),
    pageNav = $('#pageNav'),
    menuItems = $('.page-nav__menu > .menu-item'),
    menuItemLinks = $('.page-nav__menu > .menu-item > a'),
    subMenus = $('.sub-menu'),
    menuOpenClass = 'sub-menu--open',
    itemOpenClass = 'menu-item--open';
  
  // Functions
  const resetAllValues = function () {
    menuItems.removeClass(itemOpenClass);
    menuItemLinks.removeClass(menuOpenClass);
    subMenus.slideUp(300);
  };
  
  const toggleMenu = function (item, action) {
    var thisItem = item,
      thisParent = thisItem.parent(),
      thisSubMenu = thisItem.next();
  
    if (action === 'close') {
      thisParent.removeClass(itemOpenClass);
      thisItem.removeClass(menuOpenClass);
      thisSubMenu.slideUp();
    }
  
    if (action === 'open') {
      thisParent.addClass(itemOpenClass);
      thisItem.addClass(menuOpenClass);
      thisSubMenu.slideDown(300);
    }
  }
  
  // Binds
  menuMobileIcon.on('click', function () {
    pageNav.toggleClass('page-nav--open');
  });
  
  menuItemLinks.on('click', function (event) {
    event.preventDefault();
    var thisItem = $(this);
  
    if (thisItem.hasClass(menuOpenClass)) {
      toggleMenu(thisItem, 'close');
    } else {
      resetAllValues();
      toggleMenu(thisItem, 'open');
    }
  });
  

})
